import { StyleSheet } from 'aphrodite/no-important';
import { POSITION, COLORS, FONTS } from '../styles';

export default StyleSheet.create({
  faqSection: {
    position: POSITION.RELATIVE,
    padding: '100px 20px 120px',
    background: COLORS.GRAY4,
    textAlign: 'center',

    ':before': {
      position: POSITION.ABSOLUTE,
      content: '""',
      width: '100%',
      height: 80,
      top: 0,
      left: 0,
      zIndex: 2,
      pointerEvents: 'none',
      background: `linear-gradient(to bottom left, ${COLORS.WHITE} 50%, ${COLORS.TRANSPARENT} 51%)`,

      '@media (max-width: 768px)': {
        display: 'none',
      },
    },

    ':after': {
      position: POSITION.ABSOLUTE,
      content: '""',
      width: '100%',
      height: 80,
      bottom: 0,
      left: 0,
      zIndex: 2,
      pointerEvents: 'none',
      background: `linear-gradient(to top right, ${COLORS.WHITE} 50%, ${COLORS.TRANSPARENT} 51%)`,

      '@media (max-width: 768px)': {
        display: 'none',
      },
    },

    '@media (max-width: 768px)': {
      padding: '40px 20px',
    },
  },

  faqInner: {
    position: POSITION.RELATIVE,
    maxWidth: 800,
    margin: '0 auto',
    padding: '40px 0 0',
    zIndex: 10,
    textAlign: 'left',
    ...FONTS.OPEN_SANS,
  },

  faqTitle: {
    position: POSITION.RELATIVE,
    display: 'inline-block',
    ...FONTS.RAMA_E,
    fontSize: 36,
    fontWeight: 400,
    padding: '10px',
    marginBottom: 20,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: COLORS.WHITE,
    background: COLORS.PINK,

    '@media (max-width: 640px)': {
      fontSize: 28,
    },
  },

  faqItem: {
    borderBottom: `1px solid ${COLORS.GRAY3}`,
    marginBottom: 0,
  },

  faqQuestion: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '18px 0',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 600,
    color: COLORS.GRAY5,
    userSelect: 'none',

    ':hover': {
      color: COLORS.PINK,
    },
  },

  faqIcon: {
    fontSize: 22,
    fontWeight: 300,
    marginLeft: 16,
    flexShrink: 0,
    color: COLORS.PINK,
  },

  faqAnswer: {
    paddingBottom: 18,
    fontSize: 15,
    lineHeight: 1.7,
    color: COLORS.GRAY2,
  },

  faqAnswerHidden: {
    display: 'none',
  },
});
